import {ChangeDetectorRef, Component, ElementRef, HostBinding, Input, OnInit, Renderer2, ViewChild} from '@angular/core';

import {TemperatureUnit} from '../../../../shared';
import {Device} from '../../../../afb-api/models/device';

@Component({
  selector: 'awair-noti-tooltip',
  templateUrl: './noti-tooltip.component.html',
  styleUrls: ['./noti-tooltip.component.scss']
})
export class NotiTooltipComponent implements OnInit {

  @HostBinding('style.position') position = 'absolute';
  @HostBinding('style.visibility') visibility = 'hidden';
  @HostBinding('style.pointer-events') pointerEvents = 'none';

  @ViewChild('tooltipDiv') tooltipDiv: ElementRef;

  @Input() temperatureUnit: TemperatureUnit;
  @Input() isPinned: boolean = false;

  get notiTooltipInput(): INotiTooltipInput {
    return this._notiTooltipInput;
  }

  @Input()
  set notiTooltipInput(value: INotiTooltipInput) {
    if (value != null && value.value != null && !this.isPinned) {
      this.visibility = 'visible';
      this._notiTooltipInput = Object.assign({}, value);

      this.cdRef.detectChanges();

      this.positionTooltip(this.el.nativeElement, value.position);
    }
  }
  private _notiTooltipInput: INotiTooltipInput;

  constructor(private el: ElementRef,
              private renderer: Renderer2,
              private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  removeTooltip(): void {
    this.visibility = 'hidden';
  }

  private positionTooltip(nativeElement: HTMLElement, position: { x: number, y: number }) {
    const clientRect: ClientRect = nativeElement.getBoundingClientRect();

    // Tooltip's absolute y position - tooltip box height - indicator circle half radius - tooltip bottom arrow size - offset
    this.renderer.setStyle(nativeElement, 'top', (position.y - clientRect.height - 3 - 10 - 3) + 'px');
    this.renderer.setStyle(nativeElement, 'left', (position.x + 4) + 'px');
  }
}

export interface INotiTooltipInput {
  date: Date;
  type: string;
  position: { x: number, y: number };
  value: number;
  selectedDevice: Device;
}
